import { Injectable } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { HttpHeaderContentType } from '../shared/Enums';

@Injectable({ providedIn: 'root' })
export class PrintAndDownloadUtilities {
    printFromIframe(iframeElement: HTMLElement) {
        const printFrame = iframeElement as HTMLIFrameElement;
        printFrame.contentWindow.print();
    }

    printFromObjectUrl(url: SafeResourceUrl) {
        const iframe: HTMLIFrameElement = document.createElement('iframe');
        iframe.style.visibility = 'hidden'; // the user doesn't need to see this
        document.body.appendChild(iframe);
        iframe.src = <string>url;
        iframe.onload = () => {
            this.printFromIframe(iframe);
        };
    }

    // Source: https://stackoverflow.com/a/33542499/1454074
    downloadCSV(filename: string, data: string): void {
        this.download(filename, new Blob([data], { type: 'text/csv' }));
    }

    download(filename: string, blob: Blob) {
        const elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }

    downloadFromSafeResourceUrl(filename: string, url: BlobPart) {
        const blob = new Blob([url], {
            type: HttpHeaderContentType.PDF
        });
        this.download(filename, blob);
    }
}
